<template>
  <div class="mb-2">
    <div
      class="d-flex align-center"
      :style="expandable ? 'cursor: pointer;' : ''"
      @click="expandable && (expanded = !expanded)">
      <v-progress-circular
        v-if="step.status === 'loading'"
        indeterminate
        size="16"
        width="2"
        color="primary"
        class="mr-2"
      ></v-progress-circular>
      <v-icon v-else-if="step.status === 'success'" color="green" size="18" class="mr-2">mdi-check-circle</v-icon>
      <v-icon v-else-if="step.status === 'error'" color="red" size="18" class="mr-2">mdi-close-circle</v-icon>
      <v-icon v-else-if="step.status === 'warning'" color="amber-darken-2" size="18" class="mr-2">mdi-alert-circle</v-icon>
      <v-icon v-else-if="step.status === 'blocked'" color="grey" size="18" class="mr-2">mdi-minus-circle-outline</v-icon>
      <v-icon v-else color="grey-lighten-1" size="18" class="mr-2">mdi-circle-outline</v-icon>

      <span :class="{
        'text-red': step.status === 'error',
        'text-amber-darken-3': step.status === 'warning',
        'text-medium-emphasis': step.status === 'blocked' || step.status === 'pending',
      }">
        {{ statusMessage || step.label }}
      </span>

      <v-icon v-if="expandable" size="18" class="ml-1" color="grey">
        {{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
      </v-icon>
    </div>

    <div v-if="expandable && expanded" class="ml-6 mt-1">
      <StepStatus
        v-for="child in (step.children || [])"
        :key="child.key"
        :step="child"
        class="mb-1"
      ></StepStatus>

      <div v-if="step.request !== undefined || step.response !== undefined">
        <a href="#" class="text-caption" @click.prevent="consoleShown = !consoleShown">
          {{ consoleShown ? 'Ocultar consola' : 'Ver consola' }}
        </a>
        <div v-if="consoleShown" class="mt-1">
          <div v-if="step.requestUrl" class="text-caption mb-1">
            <span class="text-medium-emphasis">{{ step.requestMethod }} {{ urlOrigin(step.requestUrl) }}</span><strong>{{ urlPath(step.requestUrl) }}</strong>
          </div>
          <div v-if="step.request !== undefined && step.request !== null" class="mb-2">
            <div class="text-caption text-medium-emphasis">Request</div>
            <vue-json-pretty :data="step.request"></vue-json-pretty>
          </div>
          <div v-if="step.response !== undefined">
            <div class="text-caption text-medium-emphasis">Response</div>
            <vue-json-pretty :data="step.response"></vue-json-pretty>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueJsonPretty from 'vue-json-pretty';
  export default {
    name: 'StepStatus',
    components: {
      VueJsonPretty
    },
    props: {
      step: { type: Object, required: true },
    },
    data: () => ({
      expanded: false,
      consoleShown: false,
    }),
    computed: {
      expandable() {
        return Boolean((this.step.children && this.step.children.length) || this.step.request !== undefined || this.step.response !== undefined);
      },
      statusMessage() {
        if ((this.step.status === 'error' || this.step.status === 'warning' || this.step.status === 'blocked') && this.step.message) {
          return this.step.message;
        }
        return '';
      },
    },
    methods: {
      urlOrigin(url) {
        try {
          return new URL(url).origin;
        } catch (e) {
          return url;
        }
      },
      urlPath(url) {
        try {
          const parsed = new URL(url);
          return parsed.pathname + parsed.search;
        } catch (e) {
          return '';
        }
      },
    },
  }
</script>
